import useSWRMutation from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type {
  AccountTransactionDraft,
  CreateTransactionResponse,
} from '@mls-wallet/shared-types';

/**
 * Create a new transaction (token transfer or contract interaction)
 *
 * Uses SWR mutation for optimized loading and error states
 */
export function useCreateTransaction() {
  const { trigger, isMutating, error, reset } = useSWRMutation(
    '/transactions',
    async (_key: string, { arg }: { arg: AccountTransactionDraft }) => {
      const response = await denApi.post<
        CreateTransactionResponse,
        AccountTransactionDraft
      >('transactions', arg);

      if (!response.success) {
        throw new Error('Failed to create transaction');
      }

      return response.transaction;
    }
  );

  return {
    createTransaction: trigger,
    isSubmitting: isMutating,
    error: error
      ? error instanceof Error
        ? error.message
        : 'Failed to create transaction'
      : null,
    clearError: reset,
  };
}
